import { useTextTranslation } from "../../utils/useTextTranslation";
import React from "react";

const Genre = ({ item, selectedItem, onSelect, marginLeft, minWidth }) => {
  const translateText = useTextTranslation();
  return (
    <div
      className="genre-box"
      style={{ marginLeft: marginLeft, minWidth: minWidth }}
      onClick={() => onSelect(item)}
    >
      <div
        className={
          selectedItem?.id === item?.id
            ? "genre-text selected-genre"
            : "genre-text"
        }
      >
        {translateText(item.name)}
      </div>
    </div>
  );
};

export default Genre;
